import { createContext, useContext } from 'react'

/**
 * Los pasos del registro se reutilizan dentro de una solicitud de modificación. En el
 * registro una baja es inmediata; en la solicitud solo queda propuesta y se aplica al
 * aprobarla (se puede quitar del borrador o anular la solicitud). El aviso de los
 * diálogos de baja depende de eso.
 */
const ModificationModeContext = createContext(false)

export const ModificationModeProvider = ModificationModeContext.Provider

export function useDeleteWarning(): string {
  return useContext(ModificationModeContext)
    ? 'La baja quedará en la solicitud y se aplicará cuando sea aprobada.'
    : 'Esta acción no se puede deshacer.'
}
